export default "__VITE_ASSET__YoYt3GRi__"